module.exports = __webpack_public_path__ + "static/media/test-intermediate.20eb7fbd.png";